<div class="page">
    <app-component-header></app-component-header>

    <div class="container mt-5 content">
        <section class="feature-section">
            <div class="container">
                <div class="js-active" data-animation="scaleIn">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 mx-auto">
                            <div class="section-title text-center mb-30">
                                <div class="step-title-view wow fadeInUp" [innerHtml]="titile_page"> </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="isShowCheckGuarantee">
                        <div class="col-lg-12 col-md-12">
                            <!--  view form -->
                            <div class="service-box box-style">
                                <!--head -->
                                <div class="box-head bg-blue">
                                    <div class="title-head"><img src="assets/img/template/info-card.png" alt="icon"
                                            class="icon-f img-fluid "> Thông tin của chứng thư
                                        <span class="icon-arrow"><img src="assets/img/template/arrow.png" alt="icon"
                                                class="img-fluid"></span>
                                    </div>
                                </div>
                                <div class="box-content">
                                    <div class="row" style="padding-bottom: 10px;">
                                        <div class="col-lg-6 sugar-col-left">
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Số Sêri (BL thông thường):
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{soSerial}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!soSerial" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <!-- end row -->
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Ngày phát hành:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{ngayPhatHanh}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!ngayPhatHanh" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <!-- end row -->
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Đơn vị ký phát hành:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{donViKyPhathanh}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!donViKyPhathanh" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <!-- end row -->
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Chức vụ tại thời điểm phát hành:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{chucVu}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!chucVu" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <!-- end row -->
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Số tiền bằng chữ:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{soTienBangChu}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!soTienBangChu" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <!-- end row -->
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Số chứng thư bảo lãnh:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{soChungThuBaoLanh}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!soChungThuBaoLanh" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Đơn vị quản lý hồ sơ:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{donViQuanLyHoSo}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!donViQuanLyHoSo" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Người ký phát hành:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{nguoiKy}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!nguoiKy" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Số tiền bảo lãnh:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{soTien}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!soTien" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <div class="box-view" *ngIf="thoiHanBaoLanh">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Thời hạn bảo lãnh:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{thoiHanBaoLanh}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!thoiHanBaoLanh" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="service-box box-style">
                                <!--head -->
                                <div class="box-head bg-blue">
                                    <div class="title-head"><img src="assets/img/template/Info-DN.png" alt="icon"
                                            class="icon-f img-fluid "> Bên được bảo lãnh
                                        <span class="icon-arrow"><img src="assets/img/template/arrow.png" alt="icon"
                                                class="img-fluid"></span>
                                    </div>
                                </div>
                                <div class="box-content">
                                    <div class="row" style="padding-bottom: 10px;">
                                        <div class="box-view col-lg-12">
                                            <div class="row">
                                                <label class="textview-left col-2-5 col-form-label">
                                                    Mã số thuế/ Giấy phép ĐKKD (KH DN) hoặc CMND/ Passport (KH CN):
                                                </label>
                                                <div class="textview-right col-9-5 col-form-label">
                                                    {{passportIdTaxCode}}<nz-spin class="inline-spinner"
                                                        [nzSize]="'small'" *ngIf="!passportIdTaxCode" nzSimple>
                                                    </nz-spin>
                                                </div>
                                            </div>
                                            <div class="edit"><a href="#">&nbsp;</a></div>
                                        </div><!-- end row -->
                                        <div class="box-view col-lg-12">
                                            <div class="row">
                                                <label class="textview-left col-2-5 col-form-label">Tên:</label>
                                                <div class="textview-right col-9-5 col-form-label">
                                                    {{benDuocBaoLanh}}<nz-spin class="inline-spinner" [nzSize]="'small'"
                                                        *ngIf="!benDuocBaoLanh" nzSimple>
                                                    </nz-spin>
                                                </div>
                                            </div>
                                            <div class="edit"><a href="#">&nbsp;</a></div>
                                        </div><!-- end row -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="isShowCheckGuarantee">
                        <div class="col-lg-12 col-md-12">
                            <div class="service-box box-style">
                                <!--head -->
                                <div class="box-head bg-blue">
                                    <div class="title-head"><img src="assets/img/template/Info-DN.png" alt="icon"
                                            class="icon-f img-fluid "> Bên thụ hưởng
                                        <span class="icon-arrow"><img src="assets/img/template/arrow.png" alt="icon"
                                                class="img-fluid"></span>
                                    </div>
                                </div>
                                <div class="box-content">
                                    <div class="row" style="padding-bottom: 10px;">
                                        <!-- <div class="col-lg-6 sugar-col-left"> -->
                                        <div class="box-view col-lg-12">
                                            <div class="row">
                                                <label class="textview-left col-2-5 col-form-label">
                                                    Tên:
                                                </label>
                                                <div class="textview-right col-9-5 col-form-label">
                                                    {{benThuHuongBaoLanh}}<nz-spin class="inline-spinner"
                                                        [nzSize]="'small'" *ngIf="!passportIdTaxCode" nzSimple>
                                                    </nz-spin>
                                                </div>
                                            </div>
                                            <div class="edit"><a href="#">&nbsp;</a></div>
                                        </div>
                                        <!-- end row -->
                                        <div class="box-view">
                                            <div class="row col-lg-12">
                                                <label class="textview-left col-2-5 col-form-label">Địa chỉ:</label>
                                                <div class="textview-right col-9-5 col-form-label">
                                                    {{diaChi}}<nz-spin class="inline-spinner" [nzSize]="'small'"
                                                        *ngIf="!benDuocBaoLanh" nzSimple>
                                                    </nz-spin>
                                                </div>
                                            </div>
                                            <div class="edit"><a href="#">&nbsp;</a></div>
                                        </div><!-- end row -->
                                        <!-- </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="service-box box-style">

                                <!--head -->
                                <div class="box-head bg-blue">
                                    <div class="title-head"><img src="assets/img/template/Info-Hand.png" alt="icon"
                                            class="icon-f img-fluid" style="padding-right: 10px;padding-top: 5px;"> Ghi
                                        chú
                                        <span class="icon-arrow"><img src="assets/img/template/arrow.png" alt="icon"
                                                class="img-fluid"></span>
                                    </div>
                                </div>
                                <!-- end head -->

                                <!-- content view -->
                                <div class="box-content">
                                    <div class="row">
                                        <div class="col-lg-12 mt-10 mb-20">
                                            <div class="text-view" style="text-align:justify;">
                                                <p>
                                                    1. Quý khách hàng cần chọn đúng loại thư bảo lãnh: Thư bảo lãnh
                                                    thông thường hoặc Thư bảo lãnh thuế điện tử, nhập đúng thông tin Số
                                                    chứng thư bảo lãnh, Số Sêri được hiển thị trên chứng thư (đối với
                                                    Thư bảo lãnh thông thường)/ hoặc Số chứng từ (đối với
                                                    Thư bảo lãnh thuế điện tử) và Mã xác thực theo hình ảnh hiển thị
                                                    trên màn hình để tra cứu nhằm xác thực thông tin chứng thư.
                                                </p>
                                                <p>
                                                    2. Chương trình chỉ hỗ trợ tra cứu đối với:
                                                </p>
                                                <p>
                                                    Các Thư bảo lãnh thông thường được các Đơn vị hiện hữu [1] của
                                                    SACOMBANK phát hành từ ngày 01/07/2013 trở đi, hoặc các Đơn vị sáp
                                                    nhập [2] của SACOMBANK phát hành từ ngày 01/10/2015 trở đi.
                                                </p>
                                                <p>
                                                    [1]: là các Chi nhánh/ Phòng giao dịch của SACOMBANK trước thời điểm
                                                    Ngân hàng TMCP Phương Nam (Southern Bank) chính thức sáp nhập vào
                                                    SACOMBANK.

                                                </p>
                                                <p>
                                                    [2]: là các Chi nhánh/ Phòng giao dịch được sáp nhập từ Ngân hàng
                                                    TMCP Phương Nam (Southern Bank) vào SACOMBANK.
                                                </p>
                                                <p>
                                                    Các Thư bảo lãnh thuế điện tử được SACOMBANK phát hành từ ngày
                                                    30/06/2015 trở đi.
                                                </p>
                                                <p>
                                                    3. Trong trường hợp không thực hiện được việc tra cứu, vui lòng liên
                                                    hệ Trung tâm dịch vụ khách hàng của SACOMBANK, email:
                                                    ask@sacombank.com, điện thoại: 1900 5555 88 hoặc Chi nhánh SACOMBANK
                                                    theo thông tin ghi trên chứng thư để được hỗ trợ.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="isShowResultDepositContract">
                        <div class="col-lg-12 col-md-12">
                            <!--  view form -->
                            <div class="service-box box-style">
                                <!--head -->
                                <div class="box-head bg-blue">
                                    <div class="title-head"><img src="assets/img/template/info-card.png" alt="icon"
                                            class="icon-f img-fluid "> Khách hàng
                                        <span class="icon-arrow"><img src="assets/img/template/arrow.png" alt="icon"
                                                class="img-fluid"></span>
                                    </div>
                                </div>
                                <div class="box-content">
                                    <div class="row" style="padding-bottom: 10px;">
                                        <div class="col-lg-6 sugar-col-left">
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Tên giao dịch hoặc tên viết tắt:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{custName}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!custName" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <!-- end row -->
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Số tiền gửi:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{principalAmount}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!principalAmount" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <!-- end row -->
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Lãi suất:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{intRate}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!intRate" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <!-- end row -->
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Trạng thái:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{custContractStatus}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!custContractStatus" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <!-- end row -->
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Số hợp đồng tiền gửi:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{acctID}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!acctID" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Thời hạn gửi tiền:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{term}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'" *ngIf="!term"
                                                            nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Ngày gửi tiền:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{openDate}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!openDate" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="service-box box-style">
                                <!--head -->
                                <div class="box-head bg-blue">
                                    <div class="title-head"><img src="assets/img/template/Info-DN.png" alt="icon"
                                            class="icon-f img-fluid "> Bên nhận gửi (Ngân hàng)
                                        <span class="icon-arrow"><img src="assets/img/template/arrow.png" alt="icon"
                                                class="img-fluid"></span>
                                    </div>
                                </div>
                                <div class="box-content">
                                    <div class="row" style="padding-bottom: 10px;">
                                        <div class="col-lg-6 sugar-col-left">
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Tên CN/PGD:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{branchName}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!branchName" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <!-- end row -->
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">
                                                        Người đại diện:
                                                    </label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{customerName}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!customerName" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                                <div class="edit"><a href="#">&nbsp;</a></div>
                                            </div>
                                            <!-- end row -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="block-formControl" *ngIf="qrType == 5 || qrType == 7">
                        <div class="document-container">
                            <!-- <ngx-doc-viewer [url]="eFormUrl" viewer="url" class="doc-viewer"></ngx-doc-viewer> -->
                            <ngx-extended-pdf-viewer [src]="eFormUrl" [useBrowserLocale]="true"
                                [showRotateButton]="false" style="height: 100%; width:100%" [delayFirstView]="1000"
                                [showHandToolButton]="false" [showSpreadButton]="false" [handTool]="false"
                                [showFindButton]="false" [showPropertiesButton]="false" [showDownloadButton]="false"
                                [showPagingButtons]="false" [showBookmodeButton]="false" [showPrintButton]="false"
                                [showOpenFileButton]="false" [showSecondaryToolbarButton]="false" [showSidebarButton]="true">
                            </ngx-extended-pdf-viewer>
                        </div>
                    </div>
                    <div *ngIf="isShowLoginDepositContract">
                        <form nz-form [formGroup]="checkForm">
                            <div class="text-center">
                                <input [nzSize]="'large'" nz-input type="password" #txtPassword
                                    class="cutom-input-login" placeHolder="Vui lòng nhập Mật khẩu HĐĐT/KHTT"
                                    formControlName="password" />
                            </div>
                        </form>
                        <div class="my-3 text-center div-center">
                            <button nz-button nzType="primary" nzSize="large" nzShape="round" class="btn-sacom-o"
                                (click)="loginDepositContract()" *ngIf="!isLoading">Đăng nhập</button>
                            <button nz-button nzType="primary" nzSize="large" nzShape="round"
                                class="btn-sacom-o btnDisabled" *ngIf="isLoading">Đang xử lý</button>
                        </div>
                        <div class="mt-3" style="color: red;">
                            (*) Nếu khách hàng chưa có mật khẩu đăng nhập trang &nbsp;<span class="text-priority">
                                Hóa đơn điện tử (HĐĐT)</span>&nbsp; hoặc &nbsp;<span class="text-priority">Khách hàng
                                thân thiết (KHTT)</span>, vui lòng nhấp chọn <a
                                href="https://hoadondientu.sacombank.com/">vào đây</a> để đăng ký.
                        </div>
                    </div>
                    <div class="row" *ngIf="isShowDepositQREnquiry">
                        <div class="col-lg-12 col-md-12" *ngIf="depositQREnquiry?.accountStatus == 1">
                            <!--  view form -->
                            <div class="service-box box-style">
                                <div class="box-content">
                                    <div class="row" style="padding-bottom: 10px;">
                                        <div class="col-lg-6 sugar-col-left">
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">Chủ sở
                                                        hữu:</label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{depositQREnquiry?.customerName}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!depositQREnquiry?.customerName" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">Tên sản
                                                        phẩm:</label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{depositQREnquiry?.productName}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!depositQREnquiry?.productName" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">Số tài
                                                        khoản:</label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{depositQREnquiry?.accountNumber}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!depositQREnquiry?.accountNumber" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">Số tiền tiết
                                                        kiệm:</label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{depositQREnquiry?.amount}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!depositQREnquiry?.amount" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">Loại
                                                        tiền:</label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{depositQREnquiry?.currency}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!depositQREnquiry?.currency" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">Kỳ hạn:</label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{depositQREnquiry?.term}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!depositQREnquiry?.term" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 sugar-col-right-new">
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">Lãi suất
                                                        (%/năm):</label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{depositQREnquiry?.interestRate}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!depositQREnquiry?.interestRate" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">Ngày gửi
                                                        tiền:</label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{depositQREnquiry?.createDate}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!depositQREnquiry?.createDate" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">Ngày hiệu lực
                                                        gần nhất:</label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{depositQREnquiry?.valueDate}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!depositQREnquiry?.valueDate" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">Ngày đến
                                                        hạn:</label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{depositQREnquiry?.maturityDate}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!depositQREnquiry?.maturityDate" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">Phương thức trả
                                                        lãi:</label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{depositQREnquiry?.paymentMethod}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!depositQREnquiry?.paymentMethod" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="box-view">
                                                <div class="row">
                                                    <label class="textview-left col-lg-5 col-form-label">Chi nhánh
                                                        mở:</label>
                                                    <div class="textview-right col-lg-7 col-form-label">
                                                        {{depositQREnquiry?.companyName}}
                                                        <nz-spin class="inline-spinner" [nzSize]="'small'"
                                                            *ngIf="!depositQREnquiry?.companyName" nzSimple>
                                                        </nz-spin>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12" *ngIf="depositQREnquiry?.accountStatus == -1">
                            <div class="text-highlight text-center pt-3">
                                Tài khoản của quý khách đã tất toán!
                            </div>
                            <div class="mt-3 text-result text-center">
                                <img src="assets/img/qrcode-tattoan.png" alt="icon" class="img-fluid">
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12" *ngIf="depositQREnquiry?.accountStatus == -2">
                            <div class="text-highlight text-center pt-3">
                                QRCode bị lỗi hoặc không chính xác. Quý khách vui lòng liên hệ CN/PGD của SACOMBANK gần
                                nhất để được hỗ trợ!
                            </div>
                            <div class="mt-3 text-result text-center">
                                <img src="assets/img/qrcode-error.png" alt="icon" class="img-fluid">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <div *ngIf="isLoading" class="loading-container">
        <div class="loading-spin">
            <ng-template #indicatorTemplate><i nz-icon nzType="loading"></i></ng-template>
            <nz-spin nzSimple [nzSize]="'large'" [nzIndicator]="indicatorTemplate"></nz-spin>
        </div>
    </div>

    <app-component-footer></app-component-footer>
</div>